import { useEffect } from 'react';
import { useHistory } from 'react-router';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { CYBER } from './constantes/general';

const CyberPago= ({qParams:{idPoliza}}) => {
    const history = useHistory();
   
    useEffect(() => {
        history.replace(`${CYBER.urls.vigencia}?idPoliza=${idPoliza}`);
        history.push(`/pago?idPoliza=${idPoliza}&codProducto=${PRODUCTOS.CYBER}`);
    }, [history, idPoliza]);

    return null;
};

export default CyberPago

